import { getAuthAxiosBackend } from "../helpers/axios"

class RoleServices{

    getAll(){
        return getAuthAxiosBackend().get('roles')
    }
}

export default new RoleServices()